<template>
  <vs-button v-if="!isUndefined(title)" @click="click" class="createNewBtn" color="primary" type="border">
    <feather-icon icon="PlusIcon" class="btnIcon" svgClasses="h-4 w-4"/> {{ title }}
  </vs-button>
</template>

<script>
export default {
  props: {
    click: { type: Function },
    title: { type: String },
  },
}
</script>

<style lang="css" scoped>
  .createNewBtn {
    padding: 12px 15px;
    height: 50px;
    font-weight: 500;
    border-radius: 10px;
  }
</style>
